import { Base } from "@studiometa/js-toolkit";
import { ActionEvent } from "./ActionEvent.js";
class Action extends Base {
  static config = {
    name: "Action",
    options: {
      on: {
        type: String,
        default: "click"
      },
      target: String,
      effect: String
    }
  };
  /**
   * @private
   */
  __actionEvents;
  get actionEvents() {
    if (this.__actionEvents) {
      return this.__actionEvents;
    }
    const { on } = this.$options;
    this.__actionEvents = /* @__PURE__ */ new Set();
    for (const attribute of this.$el.attributes) {
      if (attribute.name.includes("on:")) {
        const name = attribute.name.split("on:").pop();
        this.__actionEvents.add(new ActionEvent(this, name, attribute.value));
      }
    }
    if (on) {
      const { target, effect } = this.$options;
      const effectDefinition = target ? `${target}${ActionEvent.effectSeparator}${effect}` : effect;
      this.__actionEvents.add(new ActionEvent(this, on, effectDefinition));
    }
    return this.__actionEvents;
  }
  /**
   * Mounted
   */
  mounted() {
    for (const actionEvent of this.actionEvents) {
      actionEvent.attachEvent();
    }
  }
  /**
   * Destroyed
   */
  destroyed() {
    for (const actionEvent of this.actionEvents) {
      actionEvent.detachEvent();
    }
  }
}
export {
  Action
};
//# sourceMappingURL=Action.js.map
